import { render, staticRenderFns } from "./apiRelease.vue?vue&type=template&id=634acd44&scoped=true"
import script from "./apiRelease.vue?vue&type=script&lang=js"
export * from "./apiRelease.vue?vue&type=script&lang=js"
import style0 from "./apiRelease.vue?vue&type=style&index=0&id=634acd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634acd44",
  null
  
)

export default component.exports